import axios from 'axios';

export async function downloadLog(date) {
    const response = await axios.get(`/logs/${date}`, { responseType: 'blob' });
    return response.data;
}

export async function downloadAppInsightsLog(date) {
    const response = await axios.get(`/logs/appinsights/${date}`, { responseType: 'blob' });
    return response.data;
}
